"use client";

import React from "react";

//Styled
import * as S from "./styled";

// Components
import LabelInput from "@/components/label";
import { Switch } from "@/components/ui/switch";

type SwitchComponentProps = {
  checked: boolean | "indeterminate";
  onCheckedChange: (value: boolean) => void;
  labelInput?: string;
  id?: string;
};

const SwitchComponent: React.FC<SwitchComponentProps> = ({
  checked,
  onCheckedChange,
  labelInput,
  id = "switch-input",
}) => {
  return (
    <>
      <S.SwitchStyled
        id={id}
        checked={checked === "indeterminate" ? undefined : checked}
        onCheckedChange={(value) => onCheckedChange(!!value)}
        aria-label={labelInput}
      />
      <LabelInput labelInput={labelInput} />
    </>
  );
};

export default SwitchComponent;
